<script setup>
import produitApiDrive from "@/services/http/api-drive/magasin/produit/productInfo";
import { useMagasinStore } from "@/store/magasin";
import { useContextStore } from "@/store/context";
import { useProductDetailsTracking } from "@/mixins/tracking/product-details";

const props = defineProps({
  selectedProduct: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(["closed"]);

const { $apiDrive } = useNuxtApp();
const { trackProductPage } = useProductDetailsTracking();
const { id, isNational } = useMagasinStore();
const { layout } = useContextStore();

const complementaires = ref([]);
const isVisiblePopin = ref(false);
const isLoading = ref(false);

const suggestions = computed(() => {
  return defineAsyncComponent(
    lazyComponents[`/components/organisms/product-suggestions/${layout}.vue`]
  );
});

const popup = computed(() => {
  return defineAsyncComponent(
    lazyComponents[`/components/organisms/popup-suggestions/${layout}.vue`]
  );
});

let autoDestroy;

const fetchProduitComplementaires = async () => {
  try {
    isLoading.value = true;
    const produit = await $apiDrive.use(produitApiDrive).productInfo({
      shopId: id,
      productId: props.selectedProduct.id
    });
    if (produit.data.attributes.associations.complementaire.data) {
      complementaires.value =
        produit.data.attributes.associations.complementaire.data;
    }
  } catch (err) {
    // rien à faire
  } finally {
    isLoading.value = false;
    autoDestroy = setTimeout(() => {
      if (!isVisiblePopin.value) {
        emit("closed");
      }
    }, 7000);
  }
};

const onProductIntersect = (index) => {
  if (index % 6 === 0) {
    const products =
      complementaires.value && complementaires.value.length > 0
        ? complementaires.value.slice(index - 6, index)
        : [];
    trackProductPage({
      type: trackingCodes.IMPRESSIONDONE,
      products,
      index,
      actionField: "Pop in voir les produits complementaires"
    });
  }
};

const openSuggestionPopin = () => {
  isVisiblePopin.value = true;
};

onBeforeMount(async () => {
  await fetchProduitComplementaires();
});

onUnmounted(() => {
  clearTimeout(autoDestroy);
});
</script>
<template>
  <component
    :is="popup"
    :is-loading="isLoading"
    :complementaires="complementaires"
    @openSuggestionPopin="openSuggestionPopin"
  />
  <component
    :is="suggestions"
    :selected-product="selectedProduct"
    :suggestion-products="complementaires"
    :visible="isVisiblePopin"
    :is-national="isNational"
    :is-loading="isLoading"
    :body-full-size="true"
    title="Ce produit est parfait avec..."
    @closed="isVisiblePopin = false; emit('closed')"
    @onProductIntersect="onProductIntersect"
  />
</template>
